/* eslint-disable unicorn/prefer-module, no-console */
import React, { useEffect, useRef, useState, useCallback, useMemo } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useAuthContext } from "../../context/auth";
import audienciaIcon from "../../img/landing/chile/iconos/audiencia.svg";
import consultoriaIcon from "../../img/landing/chile/iconos/consultoria.svg";
import eficienciaIcon from "../../img/landing/chile/iconos/eficiencia.svg";
import flexibilidadIcon from "../../img/landing/chile/iconos/flexibilidad.svg";
import implementacionIcon from "../../img/landing/chile/iconos/implementacion.svg";
import mantenimientoIcon from "../../img/landing/chile/iconos/mantenimiento.svg";
import respaldoIcon from "../../img/landing/chile/iconos/respaldocuantiativo.svg";
import landingFondo01 from "../../img/landing/chile/landingfondo01.jpg";
import landingFondo02 from "../../img/landing/chile/landingfondo02.jpg";
import landingFondo03 from "../../img/landing/chile/landingfondo03.jpg";
import landingFondo04 from "../../img/landing/chile/landingfondo04.jpg";
import landingFondo05 from "../../img/landing/chile/landingfondo05.jpg";
import landingFondo06 from "../../img/landing/chile/landingfondo06.jpg";
import landingFondo07 from "../../img/landing/chile/landingfondo07.jpg";
import landingFondo08 from "../../img/landing/chile/landingfondo08.jpg";
import landingFondo09 from "../../img/landing/chile/landingfondo09.jpg";
import landingFondo10 from "../../img/landing/chile/landingfondo10.jpg";
import landingFondo11 from "../../img/landing/chile/landingfondo11.jpg";
import landingFondo12 from "../../img/landing/chile/landingfondo12.png";
import { Mapa2 } from "../../pages/Mapa2";
import { getEdificiosOperativos } from "../../utils";
import logo10 from "./logos/bancopichincha.png";
import logo01 from "./logos/bbva.png";
import logo11 from "./logos/claro.svg";
import logo12 from "./logos/colgate.svg";
import logo13 from "./logos/crepier.png";
import logo25 from "./logos/cusqueñanew.png";
import logo02 from "./logos/entel.svg";
import logo03 from "./logos/epson.png";
import logo14 from "./logos/gloria.webp";
import logo08 from "./logos/hilton.svg";
import logo04 from "./logos/hyundai.png";
import logo07 from "./logos/jockeysalud.svg";
import logo15 from "./logos/latam.png";
import logo16 from "./logos/lenovo.png";
import logo05 from "./logos/lexus.png";
import logo17 from "./logos/lg.svg";
import logo18 from "./logos/mapfre.svg";
import logo19 from "./logos/mibanco.svg";
import logo06 from "./logos/nissan.svg";
import logo09 from "./logos/pacifico.png";
import logo20 from "./logos/prudential.svg";
import logo21 from "./logos/ripley.png";
import logo22 from "./logos/volvo.png";
import logo26 from "./logos/wong.png";
import logo23 from "./logos/xiaomi.svg";
import logo24 from "./logos/yango.png";
import digitalsignage from "./visiona/digital_signage.webp";
import "./LandingPagePeruNew.scss";

const LandingPeruNew = ({ pais = "Perú" }) => {
  // Estado y referencias
  const [edificios, setEdificios] = useState([]);
  const [imageSrc, setImageSrc] = useState({});
  const [currentIndex, setCurrentIndex] = useState(0);
  const heroRef = useRef(null);
  const [prevIndex, setPrevIndex] = useState(null);
  const [ismobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [totals, setTotals] = useState({
    edificios: 0,
    pantallas: 0,
    personas: 0,
    contactos: 0,
    empresas: 0,
  });

  const { pais: authPais } = useAuthContext();
  const resolvedPais = authPais || pais;

  // Lógica de logos
  const logo = useMemo(() => {
    const logos = {
      Chile: require("../../img/wecast-logo-transparente.png"),
      Perú: require("../../img/visiona-logo.png"),
      Uruguay: require("../../img/screenmedia-logo.png"),
      Region: require("../../img/adigital-logo.png"),
    };
    return logos[resolvedPais] || require("../../img/wecast-logo.png");
  }, [resolvedPais]);

  // Array de logos
  const logos = useMemo(() => {
    const logoArray = [
      { src: logo01, alt: "BBVA Logo" },
      { src: logo02, alt: "Entel Logo" },
      { src: logo03, alt: "Epson Logo" },
      { src: logo04, alt: "Hyundai Logo" },
      { src: logo05, alt: "Lexus Logo" },
      { src: logo06, alt: "Nissan Logo" },
      { src: logo07, alt: "Jockey Salud Logo" },
      { src: logo08, alt: "Hilton Logo" },
      { src: logo09, alt: "Pacifico Logo" },
      { src: logo10, alt: "Banco Pichincha Logo" },
      { src: logo11, alt: "Claro Logo" },
      { src: logo12, alt: "Colgate Logo" },
      { src: logo13, alt: "Crepier Logo" },
      { src: logo14, alt: "Gloria Logo" },
      { src: logo15, alt: "Latam Logo" },
      { src: logo16, alt: "Lenovo Logo" },
      { src: logo17, alt: "LG Logo" },
      { src: logo18, alt: "Mapfre Logo" },
      { src: logo19, alt: "Mibanco Logo" },
      { src: logo20, alt: "Prudential Logo" },
      { src: logo21, alt: "Ripley Logo" },
      { src: logo22, alt: "Volvo Logo" },
      { src: logo23, alt: "Xiaomi Logo" },
      { src: logo24, alt: "Yango Logo" },
      { src: logo25, alt: "Wong Logo" },
      { src: logo26, alt: "Cusqueña Logo" },
    ];
    // Shuffle the array using Fisher-Yates algorithm
    for (let i = logoArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [logoArray[i], logoArray[j]] = [logoArray[j], logoArray[i]];
    }
    return logoArray;
  }, []);

  // Localización
  const localString = useCallback(
    (pais) =>
      ({
        Chile: "es-CL",
        Perú: "es-PE",
        Uruguay: "es-UY",
      })[pais] || "es-UY",
    []
  );

  // Navegación
  const handleNavClick = useCallback((sectionId) => {
    document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth" });
  }, []);

  useEffect(() => {
    const initialize = async () => {
      const newEdificios = await getEdificiosOperativos({ pais: resolvedPais });
      const topEdificios = newEdificios.sort((a, b) => b.personas - a.personas).slice(0, 25);
      setEdificios(topEdificios);

      // Calculate totals for resolvedPais using ALL edificios
      const filteredEdificios = newEdificios.filter(
        (edificio) => edificio.pais === resolvedPais && edificio.estado === "OPERATIVO"
      );
      const totalEdificios = filteredEdificios.length;
      const totalPantallas = filteredEdificios.reduce(
        (sum, edificio) =>
          sum +
          (Number(edificio.pantallas || 0) +
            Number(edificio.totems || 0) +
            Number(edificio.espera || 0) +
            Number(edificio.cowork || 0)),
        0
      );
      const totalPersonas = filteredEdificios.reduce((sum, edificio) => sum + Number(edificio.personas || 0), 0);
      const totalContactos = totalPersonas * 7.5;
      const empresasSet = new Set();
      filteredEdificios.forEach((edificio) => {
        if (edificio.empresaslistado) {
          edificio.empresaslistado
            .split(/,|\r\n/)
            .map((empresa) => empresa.trim().toUpperCase())
            .filter((empresa) => empresa)
            .forEach((empresa) => empresasSet.add(empresa));
        }
      });
      const totalEmpresas = empresasSet.size;

      setTotals({
        edificios: totalEdificios,
        pantallas: totalPantallas,
        personas: totalPersonas,
        contactos: totalContactos,
        empresas: totalEmpresas,
      });
    };
    initialize();
  }, [resolvedPais]);

  useEffect(() => {
    if (edificios) {
      edificios.forEach(async (edificio) => {
        try {
          // Try to import .png first
          const src = await import(`../../img/edificios/${edificio.id}.png`);
          setImageSrc((prevState) => ({ ...prevState, [edificio.id]: src.default }));
        } catch {
          try {
            // Fallback to .jpg if .png fails
            const src = await import(`../../img/edificios/${edificio.id}.jpeg`);
            setImageSrc((prevState) => ({ ...prevState, [edificio.id]: src.default }));
          } catch {
            // If both fail, set to null
            setImageSrc((prevState) => ({ ...prevState, [edificio.id]: null }));
          }
        }
      });
    }
  }, [edificios]);

  const images = useMemo(
    () => [
      landingFondo01,
      landingFondo02,
      landingFondo03,
      landingFondo04,
      landingFondo05,
      landingFondo06,
      landingFondo07,
      landingFondo08,
      landingFondo09,
      landingFondo10,
      landingFondo11,
      landingFondo12,
    ],
    [] // Empty deps: this array is constant and won't recompute
  );

  useEffect(() => {
    // Pre-cargar imágenes
    images.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
    const interval = setInterval(() => {
      setPrevIndex(currentIndex);
      const newIndex = (currentIndex + 1) % images.length;
      setCurrentIndex(newIndex);
      setTimeout(() => setPrevIndex(null), 550);
    }, 5000);
    return () => clearInterval(interval);
  }, [currentIndex, images]); // Added 'images' here

  // Agregar useEffect para manejar resize
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Efecto parallax
  useEffect(() => {
    const handleScroll = () => {
      if (!heroRef.current) return;
      const scrollY = window.scrollY;
      const opacity = Math.max(1 - scrollY / 700, 0.2);
      const transform = `translateY(${scrollY * 0.4}px)`;
      heroRef.current.style.opacity = opacity.toString();
      heroRef.current.style.transform = transform;
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Manejo del carrusel
  const handlePrev = () => setCurrentIndex((prev) => (prev === 0 ? 0 : prev - 1));
  const handleNext = () => setCurrentIndex((prev) => (prev === edificios.length - 1 ? 0 : prev + 1));

  // Subcomponente NavLink
  const NavLink = ({ sectionId, children }) => {
    const [isFocused, setIsFocused] = useState(false);
    return (
      <button
        onClick={() => handleNavClick(sectionId)}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        className="navbar-link-peru"
        aria-current={isFocused ? "page" : undefined}
      >
        {children}
      </button>
    );
  };

  return (
    <>
      {/* NavBar */}
      <nav className="navbar-peru">
        <div className="navbar-container-peru">
          <img
            src={logo}
            alt="Logo"
            className="navbar-logo-peru"
            onError={(e) => (e.target.src = require("../../img/wecast-logo-transparente.png"))}
          />
          <div className="navbar-nav-peru">
            <NavLink sectionId="servicios">Servicios</NavLink>
            <NavLink sectionId="cobertura">Cobertura</NavLink>
            <NavLink sectionId="clientes">Clientes</NavLink>
            <NavLink sectionId="transformacion">Transformación Digital</NavLink>
          </div>
        </div>
      </nav>
      {/* Main Content */}
      <main className="main">
        <section className="hero-section-peru">
          <div className="hero-background-peru" ref={heroRef}>
            {prevIndex !== null && (
              <div
                className="background-slide-peru prev-peru"
                style={{
                  backgroundImage: `url(${images[prevIndex]})`,
                  backgroundSize: "cover",
                }}
              />
            )}
            <div
              className="background-slide-peru current-peru"
              style={{
                backgroundImage: `url(${images[currentIndex]})`,
                backgroundSize: "cover",
              }}
              key={currentIndex}
            />
          </div>
          <div className="hero-overlay-peru" />
          <div className="hero-content-peru">
            <h1>
              <span>Publicidad Digital</span> <br /> en Torres Ejecutivas
            </h1>
            <div className="hero-content-bajada-peru">
              Conecte su marca con una audiencia de valor y de manera eficiente, en los espacios más exclusivos de la
              ciudad, a través de circuitos digitales dentro de edificios corporativos.
            </div>
          </div>
        </section>
        <section className="stats-section-peru">
          <div className="stats-title-peru">Alcance</div>
          <div className="stats-grid-peru">
            {[
              {
                title: "EDIFICIOS",
                value: totals.edificios.toLocaleString(localString(resolvedPais)),
              },
              {
                title: "PANTALLAS",
                value: totals.pantallas.toLocaleString(localString(resolvedPais)),
              },
              {
                title: "PERSONAS ÚNICAS",
                value: totals.personas.toLocaleString(localString(resolvedPais)),
              },
              {
                title: "CONTACTOS DIARIOS",
                value: Math.round(totals.contactos).toLocaleString(localString(resolvedPais)),
              },
              {
                title: "EMPRESAS",
                value: totals.empresas.toLocaleString(localString(resolvedPais)),
              },
            ].map((stat, index) => (
              <div key={index} className="stats-item-peru">
                <div className="stats-value-peru">{stat.value}</div>
                <div className="stats-label-peru">{stat.title}</div>
              </div>
            ))}
          </div>
        </section>
        <section id="servicios" className="ventajas-section-peru">
          <div className="ventajas-title-peru">Ventajas y Beneficios</div>
          <div className="ventajas-subtitle-peru">Acceda a una plataforma innovadora con ventajas únicas</div>
          <div className="ventajas-grid-peru">
            {[
              {
                icon: audienciaIcon,
                title: "AUDIENCIA PREMIUM",
                text: "Conocimiento preciso del perfil de la audiencia (B2C) y de las empresas en cada edificio (B2B), alcance decenas de miles de ejecutivos, profesionales y tomadores de decisión de empresas destacadas.",
              },
              {
                icon: respaldoIcon,
                title: "RESPALDO CUANTITATIVO",
                text: "Cantidad de individuos respaldada por los propios edificios gracias a sus sistemas de acceso, data fiable y precisa con detalle de visitas y frecuencia de accesos.",
              },
              {
                icon: flexibilidadIcon,
                title: "FLEXIBILIDAD DE PAUTA",
                text: "Tradicional o programática, por día en un único edificio o todo el año en toda la red, alta o baja frecuencia de apariciones según requiera su estrategia.",
              },
              {
                icon: eficienciaIcon,
                title: "EFICIENCIA EN EL IMPACTO",
                text: "Soportes en ambientes de espera obligada con contenidos de valor que garantizan una atención completa del público con alta frecuencia de repetición.",
              },
            ].map((card, index) => (
              <div key={index} className="ventajas-card-peru">
                <img src={card.icon} alt={card.title} className="icon-peru" />
                <div className="ventajas-card-title-peru">{card.title}</div>
                <div className="ventajas-card-text-peru">{card.text}</div>
              </div>
            ))}
          </div>
        </section>
        <section id="cobertura" className="cobertura-section-peru">
          <div className="cobertura-title-peru">Cobertura</div>
          <div className="map-container-peru">
            <Mapa2 />
          </div>
        </section>
        {!ismobile && (
          <section className="torres-section-peru-nuevo">
            <div className="torres-title-peru-nuevo">Nuestras Torres Ejecutivas</div>
            <div className="torres-subtitle-peru">
              Presencia exclusiva en las principales torres de Lima con pantallas estratégicamente ubicadas dentro de
              ascensores, lobbys de acceso y halls de circulación.
            </div>
            <div className="torres-carousel-container-peru">
              {edificios.length === 0 ? (
                <div>No hay edificios disponibles.</div>
              ) : (
                <>
                  <div className="torres-carousel-peru">
                    <div
                      className="torres-carousel-inner-peru"
                      style={{ transform: `translateX(-${currentIndex * 100}%)` }}
                    >
                      {edificios.map((edificio, index) => (
                        <div key={edificio.id} className="torres-card-peru">
                          <div className="torres-visual-card-peru">
                            {imageSrc[edificio.id] ? (
                              <img src={imageSrc[edificio.id]} alt={edificio.edificio} loading="lazy" />
                            ) : (
                              <div className="image-placeholder-peru">Imagen no disponible</div>
                            )}
                            {/* <div className="torres-visual-info-peru">
                              <div className="torres-info-title-peru">{edificio.edificio || "Edificio sin nombre"}</div>
                              <div className="torres-info-subtitle-peru">
                                {edificio.ubicacion || "Ubicación no disponible"}
                              </div>
                            </div> */}
                          </div>
                          <div className="torres-info-card-peru">
                            <div className="torres-info-title-peru">{edificio.edificio || "Edificio sin nombre"}</div>
                            <div className="torres-info-subtitle-peru">
                              {edificio.ubicacion || "Ubicación no disponible"}
                            </div>
                            <div className="torres-info-subtitle-direccion-peru">
                              {edificio.direccion || "Dirección no disponible"}
                            </div>
                            <div className="torres-stats-peru">
                              <div className="stat-item-peru">
                                <div className="stat-number-peru">
                                  {edificio.personas.toLocaleString(localString(resolvedPais))}
                                </div>
                                <div className="stat-label-peru">Personas únicas diarias</div>
                              </div>
                              {edificio.pantallas > 0 && (
                                <div className="stat-item-peru">
                                  <div className="stat-number-peru">{edificio.pantallas}</div>
                                  <div className="stat-label-peru">Pantallas en ascensores</div>
                                </div>
                              )}
                              {edificio.espera > 0 && (
                                <div className="stat-item-peru">
                                  <div className="stat-number-peru">{edificio.espera}</div>
                                  <div className="stat-label-peru">Pantalla en el hall de espera</div>
                                </div>
                              )}
                              {edificio.totems > 0 && (
                                <div className="stat-item-peru">
                                  <div className="stat-number-peru">{edificio.totems}</div>
                                  <div className="stat-label-peru">Pantallas Circulación</div>
                                </div>
                              )}
                              {edificio.empresaslistado && edificio.empresaslistado.split(",").length > 0 && (
                                <div className="stat-item-peru">
                                  <div className="stat-number-peru">{edificio.empresaslistado.split(",").length}</div>
                                  <div className="stat-label-peru">Empresas instaladas</div>
                                </div>
                              )}
                            </div>
                            <hr className="separator-peru" />
                            <div className="carousel-arrows-container-peru">
                              <button
                                className="carousel-arrow-peru left-arrow-peru"
                                onClick={handlePrev}
                                disabled={edificios.length <= 1}
                              >
                                <FaChevronLeft />
                              </button>
                              <button
                                className="carousel-arrow-peru right-arrow-peru"
                                onClick={handleNext}
                                disabled={edificios.length <= 1}
                              >
                                <FaChevronRight />
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </>
              )}
            </div>
          </section>
        )}
        <section className="presencia-section-peru">
          <h2>Presencia Regional</h2>
          <p>+15 años conectando con audiencias en edificios corporativos en Uruguay, Perú y Chile.</p>
        </section>
        <section id="clientes" className="clientes-section-peru">
          <h2>Referencias Comerciales</h2>
          <p>Algunos clientes de los últimos 12 meses</p>
          <div className="clientes-logos-peru">
            <div className="carousel-track">
              {[...logos, ...logos].map((client, index) => (
                <img
                  key={index}
                  src={client.src}
                  alt={client.alt || `Logo ${index + 1}`} // Fallback si alt no está definido
                  onError={() => console.error(`Failed to load logo: ${client.alt || `Logo ${index + 1}`}`)}
                />
              ))}
            </div>
          </div>
        </section>
        {!ismobile && (
          <section id="transformacion" className="transformacion-section">
            <div className="transformacion-section-titulo">Transformación Digital</div>
            <div className="transformacion-section-subtitulo">
              Innovación que complementa su estrategia publicitaria con soluciones digitales a medida
            </div>
            <div className="transformacion-content">
              <div className="transformacion-image">
                <img src={digitalsignage} alt="Transformación Digital" />
              </div>
            </div>
            <div className="transformacion-section-bajada">
              Además de nuestra oferta publicitaria, somos expertos en transformación digital, brindando soluciones que
              potencian la comunicación de su empresa puertas adentro y hacia sus clientes.
            </div>
            <div className="transformacion-content">
              <div className="transformacion-logos">
                <img src={logo08} alt="Hilton" />
                <img src={logo07} alt="Jockey Salud" />
                <img src={logo09} alt="Pacifico" />
              </div>
            </div>
          </section>
        )}
        <section>
          <div className="soluciones-peru">
            <div className="soluciones-text-titulo-peru">Soluciones Integrales</div>
            <div className="soluciones-text-subtitulo-seccion-peru">
              Contenidos a medida, interactivos y dinámicos para comunicación efectiva
            </div>
            <div className="soluciones-tarjetas-peru">
              {[
                {
                  icon: consultoriaIcon,
                  title: "Consultoría",
                  text: "Analizamos sus necesidades y diseñamos la estrategia y estructura de cartelería digital más adecuada, creando soluciones personalizadas y efectivas para potenciar la comunicación de su empresa.",
                },
                {
                  icon: implementacionIcon,
                  title: "Implementación",
                  text: "Instalación de hardware, desarrollo de software, diseño gráfico, configuración de sistemas, todo lo necesario para poner en marcha su proyecto.",
                },
                {
                  icon: mantenimientoIcon,
                  title: "Mantenimiento",
                  text: "Soporte continuo, actualizaciones de contenido, mantenimiento preventivo y soporte reactivo, garantizando una operación sin interrupciones.",
                },
              ].map((card, index) => (
                <div key={index} className="soluciones-card-peru">
                  <img src={card.icon} alt={card.title} className="icon-peru" />
                  <h3>{card.title}</h3>
                  <p>{card.text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <footer className="footer-peru">
        <div className="footer-container-peru">
          <div className="footer-grid-peru">
            <div className="footer-right-peru">
              <div className="footer-section-peru">hola@visiona.pe</div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};
export default LandingPeruNew;
